import React, { memo } from 'react';
import { validators } from 'investira.sdk';
import { Info } from '../';

/**
 * Renderiza o componente InlineInfo.
 *
 * @returns {JSX.Element|null} Elemento renderizado ou `null` quando não houver conteúdo para exibir.
 */
const InlineInfo = memo(props => {
  const { valueProps: xValueProps = {} } = props;

  if (validators.isEmpty(props.value)) {
    return null;
  }

  return <Info {...props} type="row" valueProps={{ ...xValueProps, align: 'right' }} />;
});

InlineInfo.displayName = 'InlineInfo';

export default InlineInfo;
